"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalSSShort = void 0;
var LegalSSShort = /** @class */ (function () {
    function LegalSSShort() {
        this.legalText = 'Standard shipping<br>\n';
        this.shortLegalLinkLabel = 'Standard shipping';
    }
    return LegalSSShort;
}());
exports.LegalSSShort = LegalSSShort;
//# sourceMappingURL=legalSSshort.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/legalSSshort.cms.js
// module id = 1994
// module chunks = 8